import { css } from '@emotion/react'
import styled from '@emotion/styled'

import { Theme } from 'scripts/react-components/themes/Theme'

type Badge = {
  type: string
}

type TypeMap = {
  [type: string]: string
}

const getBackgroundColorByBadgeType = (type: string) => {
  const colors: TypeMap = {
    exclusive: 'p800',
    freeShipping: 'r700',
    outlet: 'n900',
    news: 'f500',
    productCode: 'n200',
    assistedSale: 'n200',
    expiredAvs: 'r600',
    bndes: 'p800'
  }
  return colors[type]
}

const wrapperStyles = ({ theme }: Theme) => css`
  label: wrapper;
  margin-bottom: 0;

  ${theme.media.mega} {
    margin-bottom: ${theme.spacings.giga};
  }
`

const badgeStyles = ({ theme, type }: Theme & Badge) => css`
  label: badge;

  background-color: ${theme.colors[getBackgroundColorByBadgeType(type)]};

  color: white;

  display: inline-block;

  margin-right: ${theme.spacings.byte};
  margin-top: ${theme.spacings.byte};

  border-radius: ${theme.borderRadius.tera};

  padding: 0px ${theme.spacings.byte};
`

const ratingStarWrapperStyles = ({ theme }: Theme) => css`
  label: rating-stars;
  display: block;

  ${theme.media.giga} {
    display: inline-block;
  }
`

export const Wrapper = styled('div')(wrapperStyles)
export const Badge = styled('div')(badgeStyles)
export const RatingStarsWrapper = styled('div')(ratingStarWrapperStyles)
